
import { ActionList, Badge, BlockStack, Button, InlineStack, Popover, Tooltip, Text } from "@shopify/polaris";
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import ActivityProgressModalElement from "../ActivityProgressModalElement";
import RenderErrorModalChild from "../RenderErrorModalChild";
import ProgressActivity from "../ProgressActivity";
import ProductWarningsN from "../../../Editproduct/components/ProductDetails/ProductWarningsN";
import ProductErrorsN from "../../../Editproduct/components/ProductDetails/ProductErrorsN";
import getClass from "../../../../Utilities/getClass";
import ErrorModal from "../ErrorModal";


export function SetBadgeVariation(props: any) {

    const { item, t } = props;
    let renderBadge: JSX.Element = (
        <Tooltip
          content={
            <div style={{ width: "130px" }}>
              <BlockStack gap="200">
                <BlockStack gap="100">
                  <Text as="p" fontWeight="semibold">
                    {t("BADGE_INFO")}
                  </Text>
                  <InlineStack gap="100" blockAlign="center">
                    <Text as="span">{t('SIMPLE_NOT_LISTER')}</Text>
                  </InlineStack>
                </BlockStack>
              </BlockStack>
            </div>
          }
          dismissOnMouseOut
        >
          <Badge>{t("Not Listed")}</Badge>
        </Tooltip>
      );


    switch (item?.items?.status) {

        case 'Listed':
            renderBadge = (
                <Tooltip
                  content={
                    <div style={{ width: "130px" }}>
                      <BlockStack gap="200">
                        <BlockStack gap="100">
                          <Text as="p" fontWeight="semibold">
                            {t("BADGE_INFO")}
                          </Text>
                          <InlineStack gap="100" blockAlign="center">
                            <Text as="span">{t('Listed')}</Text>
                          </InlineStack>
                        </BlockStack>
                      </BlockStack>
                    </div>
                  }
                  dismissOnMouseOut
                >
                  <span className={getClass({
                    "Custom--listed-Product-Badge": true,
                    "Custom--listed-Product-Badge-windows": navigator.userAgent.includes('Windows')
                })}>
                    <Badge tone='success' progress='complete' >{t(item?.items?.status)}</Badge>
                </span>
                </Tooltip>
              );
            break;

        case 'Not Listed':

            renderBadge = (
                <Tooltip
                  content={
                    <div style={{ width: "130px" }}>
                      <BlockStack gap="200">
                        <BlockStack gap="100">
                          <Text as="p" fontWeight="semibold">
                            {t("BADGE_INFO")}
                          </Text>
                          <InlineStack gap="100" blockAlign="center">
                            <Text as="span">{t('SIMPLE_NOT_LISTER')}</Text>
                          </InlineStack>
                        </BlockStack>
                      </BlockStack>
                    </div>
                  }
                  dismissOnMouseOut
                >
                  <Badge>{t(item?.items?.status)}</Badge>
                </Tooltip>
              );

            break;

        case 'Uploaded':
            renderBadge = (
                <Tooltip content={t("This product was uploaded successfully. Please wait for Amazon to process your product data. Check the 'Amazon Sync Status' after a few hours to move the product to the Listed category. Or, wait for the daily product sync to update the status.")} dismissOnMouseOut>
                    <Badge tone='info' progress='complete'>{t(item?.items?.status)}</Badge>
                </Tooltip>
            );
            break;
        case 'Inactive':
            renderBadge = (
                <Tooltip
                  content={
                    <div style={{ width: "130px" }}>
                      <BlockStack gap="200">
                        <BlockStack gap="100">
                          <Text as="p" fontWeight="semibold">
                            {t("BADGE_INFO")}
                          </Text>
                          <InlineStack gap="100" blockAlign="center">
                            <Text as="span">{t('INFO_INACTIVE')}</Text>
                          </InlineStack>
                        </BlockStack>
                      </BlockStack>
                    </div>
                  }
                  dismissOnMouseOut
                >
                    <Badge tone="critical">{t(item?.items?.status)}</Badge>
                </Tooltip>
              );

            break; ``

        case 'Active':
            renderBadge = (
                <Tooltip
                  content={
                    <div style={{ width: "130px" }}>
                      <BlockStack gap="200">
                        <BlockStack gap="100">
                          <Text as="p" fontWeight="semibold">
                            {t("BADGE_INFO")}
                          </Text>
                          <InlineStack gap="100" blockAlign="center">
                            <Text as="span">{t('INFO_ACTIVE')}</Text>
                          </InlineStack>
                        </BlockStack>
                      </BlockStack>
                    </div>
                  }
                  dismissOnMouseOut
                >
                    <Badge tone="success">{t(item?.items?.status)}</Badge>
                </Tooltip>
              );
            break;

        case 'Not Listed: Offer':
            renderBadge = (
                <Tooltip
                  content={
                    <div style={{ width: "130px" }}>
                      <BlockStack gap="200">
                        <BlockStack gap="100">
                          <Text as="p" fontWeight="semibold">
                            {t("BADGE_INFO")}
                          </Text>
                          <InlineStack gap="100" blockAlign="center">
                            <Text as="span">{t('INFO_NOT_LISTER_OFFER')}</Text>
                          </InlineStack>
                        </BlockStack>
                      </BlockStack>
                    </div>
                  }
                  dismissOnMouseOut
                >
                    <Badge tone="new">{t(item?.items?.status)}</Badge>
                </Tooltip>
              );
            break;
        case 'Incomplete':
            renderBadge = (
                <Tooltip
                content={
                  <div style={{ width: "130px" }}>
                    <BlockStack gap="200">
                      <BlockStack gap="100">
                        <Text as="p" fontWeight="semibold">
                          {t("BADGE_INFO")}
                        </Text>
                        <InlineStack gap="100" blockAlign="center">
                          <Text as="span">{t('INFO_INCOMPLETE')}</Text>
                        </InlineStack>
                      </BlockStack>
                    </BlockStack>
                  </div>
                }
                dismissOnMouseOut
              >
                  <Badge tone="warning">{t(item?.items?.status)}</Badge>
              </Tooltip>
            );
            break;
        case 'Ready To Upload':
            renderBadge = (
                <Badge tone="magic">{t(item?.items?.status)}</Badge>
            );
            break;

    }
    return renderBadge;
}

export function GetActivityFromRowDatavarient(props: any) {
    const { row, t, refreshAction } = props
    let renderData: JSX.Element = <></>;
    const [errorModal, openErrorModal] = useState<boolean>(false);
    const [ActivityProgressModal, setActivityProgressModal] = useState(false);
    const [warningPopover, setWarningPopover] = useState<boolean>(false);
    const [ActivityProgress, setActivityProgress] = useState<any>({});
    const [warningData, setWarningData] = useState<boolean>(false);
    if (Object.keys(row.items).includes('error') && !Object.keys(row.items).includes('warning')) {
        renderData = <BlockStack align='center' gap="100">
            <span onClick={() => {
                openErrorModal(true)
                setActivityProgress({
                    allActivity: row?.items?.items?.['process_tags'],
                    title: t('Action(s) in progress')
                })
            }}>
                <span className='gridErrorBadge'>
                    <Badge progress="incomplete" tone="critical">{t("Error")}</Badge>
                </span>
            </span>
            {
                row?.items?.['process_tags'] ?
                    Object.keys(row?.items?.['process_tags'])?.length !== 0 ?
                        <Text as='span' tone="subdued">
                            <i> {Object.keys(row?.items?.['process_tags']).length > 1 ? "1+ " : "1 "} {t("task in progress")} </i>
                        </Text>
                        : ""
                    : ""
            }
        </BlockStack>
    }
    else if (Object.keys(row.items).includes('warning') && Object.keys(row.items).includes('error')) {
        renderData = <BlockStack align='center' gap="100">
            <InlineStack gap="200">
                <span onClick={() => {
                    openErrorModal(true)
                    setActivityProgress({
                        allActivity: row?.items?.['process_tags'],
                        title: 'Action(s) in progress'
                    })
                }}>
                    <span className='gridErrorBadge'>
                        <Badge progress="incomplete" tone="critical">{t("Error")}</Badge>
                    </span>
                </span>
                {
                    row?.items?.['warning'] && <Popover
                        active={warningPopover}
                        activator={<Button variant='plain' onClick={() => setWarningPopover(!warningPopover)} size="micro" disclosure>+1</Button>}
                        autofocusTarget="first-node"
                        onClose={() => setWarningPopover(false)}
                    >
                        <ActionList
                            actionRole="menuitem"
                            items={[{
                                content: "",
                                badge: { content: 'Warning', tone: "new" },
                                onAction: () => {
                                    openErrorModal(false);
                                    setWarningData(true);

                                    setActivityProgress({
                                        allActivity: row?.items?.['process_tags'],
                                        title: t('Action(s) in progress')
                                    })

                                }
                            }]}
                        />
                    </Popover>
                }
            </InlineStack>
            {
                row?.items?.['process_tags'] ?
                    Object.keys(row?.items?.['process_tags'])?.length !== 0 ?
                        <Text as='span' tone="subdued">
                            <i> {Object.keys(row?.items?.['process_tags']).length > 1 ? "1+ " : "1 "} {t("task in progress")} </i>
                        </Text>
                        : ""
                    : ""
            }
        </BlockStack>

    }
    else if (Object.keys(row?.items).includes('warning')) {
        renderData = <BlockStack align='center' gap="100">
            <span onClick={() => {
                setWarningData(true);

                setActivityProgress({
                    allActivity: row?.items?.['process_tags'],
                    title: t('Action(s) in progress')
                })
            }}>
                <span className='gridErrorBadge'>
                    <Badge progress="incomplete" tone="warning">{t("Warning")}</Badge>
                </span>
            </span>
            {
                row?.items?.['process_tags'] ?
                    Object.keys(row?.items?.['process_tags'])?.length !== 0 ?
                        <Text as='span' tone="subdued">
                            <i> {Object.keys(row?.items?.['process_tags']).length > 1 ? "1+ " : "1 "} {t("task in progress")} </i>
                        </Text>
                        : ""
                    : ""
            }
        </BlockStack>

    }
    else if (Object.keys(row?.items).includes('process_tags')) {
        renderData = <BlockStack gap="100">
            <span onClick={() => {
                setActivityProgress({
                    allActivity: row?.items?.['process_tags'],
                    title: t('Action(s) in progress')
                });
                setActivityProgressModal(true)
            }}>
                <span className='gridInProgressBadge'>
                    <Badge tone="success" progress="complete">{t("In Progress")}</Badge>
                </span>
            </span>
            {
                row?.items?.['process_tags'] ?
                    Object.keys(row?.items?.['process_tags'])?.length !== 0 ?
                        <Text as='p' tone="subdued">
                            <i> {Object.keys(row?.items?.['process_tags']).length > 1 ? "1+ " : "1 "} {t("task in progress")} </i>
                        </Text>
                        : "" : ''
            }
        </BlockStack>

    }
    else renderData = <Text as='p' tone='subdued'><em>{t("No Ongoing Activity")}</em></Text>

    return (
        <React.Fragment>
            <React.Fragment>
                <div className='activity'>{renderData}</div>
                <ErrorModal
                    type={ 'child'}
                    id={row?.items?.source_product_id}
                    viewProductError={errorModal || warningData || ActivityProgressModal}
                    setViewProductError={errorModal ? openErrorModal : warningData ? setWarningData : ActivityProgressModal ? setActivityProgressModal : null}
                ></ErrorModal>
                {/* <ProductErrorsN
                    from='grid'
                    type={'child'}
                    id={row?.items?.source_product_id}
                    viewProductError={errorModal}
                    setViewProductError={openErrorModal}
                />

                <ProductWarningsN
                    from='grid'
                    type={"child"}
                    id={row?.items?.source_product_id}
                    viewProductWarning={warningData}
                    setViewProductWarning={setWarningData}
                />
                <ProgressActivity
                    ActivityProgressModal={ActivityProgressModal}
                    setActivityProgressModal={setActivityProgressModal}
                    activityRefreshAction={() => refreshAction()}
                    {...props}
                    from='grid'
                    type={"child"}
                    id={row?.items?.source_product_id}
                /> */}
            </React.Fragment>
        </React.Fragment>
    );
}

export const handleHeaderSelectAll = (row: any, selectedRows: any, DataforRow: any, setselectedRows: any, Rows: any) => {

    if (selectedRows.length > 0 && selectedRows.length == DataforRow.length) {
        setselectedRows([]);
    }
    else if (row.length > 0 && DataforRow.length > row.length) {
        let rowTempData: any = [];
        Rows.map((row: any) => rowTempData.push(row?.source_product_id));
        setselectedRows(rowTempData);
    }
}
